<template>
    <v-dialog v-model="value"
        :value="value"  persistent fullscreen content-class="loading-dialog">
      <v-container fill-height>
        <v-layout row justify-center align-center>
          <v-progress-circular indeterminate :size="70" :width="7" color="red lighten-1"></v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      show: this.value,
    };
  },
  watch: {
      value() {
        this.show = this.value;
        this.$emit('input', this.value);
      },
  },
  methods: {
    set(value) {
      this.show = value;
    },
  },
};
</script>

<style>
  .loading-dialog{
    background: #282c2dad;
    box-shadow: none;
    border-radius: 6px;
    color: whitesmoke;
  }
</style>
